import React from "react";
import {
  Weather,
  TopBottom,
  City,
  WatherDescription,
  WeatherIcon,
  Temperature,
  Details,
  ParameterRow,
  ParameterLabel,
  ParameterValue,
} from "./CurrentWeather.styled";

const CurrentWeather = ({ data }) => {
  return (
    <Weather>
      <TopBottom>
        <div>
          <City>{data.city}</City>
          <WatherDescription>{data.weather[0].description}</WatherDescription>
        </div>
        <WeatherIcon alt="weather" src={`icons/${data.weather[0].icon}.png`} />
      </TopBottom>
      <TopBottom>
        <Temperature>{Math.round(data.main.temp)}°C</Temperature>
        <Details>
          <ParameterRow>
            <ParameterLabel>Details</ParameterLabel>
          </ParameterRow>
          <ParameterRow>
            <ParameterLabel>Feels like</ParameterLabel>
            <ParameterValue>
              {Math.round(data.main.feels_like)}°C
            </ParameterValue>
          </ParameterRow>
          <ParameterRow>
            <ParameterLabel>Wind</ParameterLabel>
            <ParameterValue>{data.wind.speed} m/s</ParameterValue>
          </ParameterRow>
          <ParameterRow>
            <ParameterLabel>Humidity</ParameterLabel>
            <ParameterValue>{data.main.humidity}%</ParameterValue>
          </ParameterRow>
          <ParameterRow>
            <ParameterLabel>Pressure</ParameterLabel>
            <ParameterValue>{data.main.pressure} hPa</ParameterValue>
          </ParameterRow>
        </Details>
      </TopBottom>
    </Weather>
  );
};

export default CurrentWeather;
